import { Controller } from "@hotwired/stimulus"
import { reactor } from "../lib/reactor"

export default class extends Controller {
  static values = {
    count: Number,
    singular: String,
    plural: String,
  }

  connect() {
    reactor(this)
  }

  description() {
    if (this.countValue === 1)
      return `${this.countValue} ${this.singularValue}`
    else
      return `${this.countValue} ${this.pluralValue}`
  }
}
